import React from 'react'
import Link from 'next/link'
import Configs from '@/configs'
import { EmailIcon, PhoneIcon } from '@/v1/icons'
import { PrimaryAccordion } from '@/v1/components/ui'
import { GENERAL_FAQS } from '@/v1/components/faq/constants'

export function GeneralFaq() {
  const appName = Configs.APP_NAME
  const contactNo = Configs.contactNo
  const supportEmail = Configs.supportEmail

  return (
    <>
      <section className={'container general-faq-wr'}>
        <div className={'section-spacing'}>
          <h1 className={'pb-10 text-center text-secondary font-bold text-2xl md-mn:text-4xl'}>
            {appName} FAQ/Help Center
          </h1>

          <PrimaryAccordion info={GENERAL_FAQS} />

          <p className={'my-6 text-orange-primary italic text-sm'}>
            *{appName} keeps the rights to update the FAQ content anytime. Please keep checking FAQ for an update.
          </p>

          <div className={'flex items-center justify-center flex-col md-mn:flex-row gap-4 md-mn:gap-6'}>
            <p className={'text-secondary text-lg font-medium'}>Still Have Questions?</p>
            <div className={'inline-flex flex-col md-mn:flex-row gap-2 md-mn:gap-4'}>
              <div className={'inline-flex gap-2 items-center'}>
                <div className={'w-[30px] h-[30px] rounded-full bg-secondary flex items-center justify-center'}>
                  <PhoneIcon className={'text-white'} />
                </div>
                <Link href={`tel:${contactNo}`} className={'text-secondary'}>
                  {contactNo}
                </Link>
              </div>
              <div className={'inline-flex gap-2 items-center'}>
                <div className={'w-[30px] h-[30px] rounded-full bg-secondary flex items-center justify-center'}>
                  <EmailIcon className={'text-white'} />
                </div>
                <Link href={`mailto:${supportEmail}`} className={'text-secondary'}>
                  {supportEmail}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}
